import { NavItem } from "src/components/layout/nav/nav-item";
import { Icon } from "src/components/layout/nav/icons/get-started";
import { useUser } from "src/contexts/user-context";
import { UseSectionHook } from "./types";

export const useGetStartedSection: UseSectionHook = () => {
  const { isOnboarding } = useUser();

  return {
    title: "Get started",
    isEnabled: Boolean(isOnboarding),
    links: [
      {
        href: "/onboarding",
        label: "Get started",
      },
    ],
  };
};

export const GetStarted = () => {
  const { isEnabled } = useGetStartedSection();

  if (!isEnabled) {
    return null;
  }
  return <NavItem href="/onboarding" icon={Icon} label="Get started" />;
};
